export default __webpack_public_path__ + "static/media/seo1.415b09fb.png";